"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function firstArg(v) {
    return v;
}

var CNTableColumn = function (_React$Component) {
    (0, _inherits3.default)(CNTableColumn, _React$Component);

    function CNTableColumn(props) {
        (0, _classCallCheck3.default)(this, CNTableColumn);

        var _this = (0, _possibleConstructorReturn3.default)(this, (CNTableColumn.__proto__ || (0, _getPrototypeOf2.default)(CNTableColumn)).call(this, props));

        _this.cellCallback = _this.cellCallback.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(CNTableColumn, [{
        key: "cellCallback",
        value: function cellCallback() {
            return _react2.default.createElement(
                "div",
                null,
                "cell test"
            );
        }
    }, {
        key: "render",
        value: function render() {
            return null;
        }
    }]);
    return CNTableColumn;
}(_react2.default.Component);

CNTableColumn.propTypes = {
    wrap: _propTypes2.default.bool,

    titleTooltip: _propTypes2.default.oneOfType([_propTypes2.default.string]),

    contentTooltip: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(["overflow-only"])]),

    copy: _propTypes2.default.bool,
    onBeforeCopy: _propTypes2.default.func,
    onCopy: _propTypes2.default.func,

    clickToSelectRow: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,

    greedy: _propTypes2.default.bool,

    title: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.node, _propTypes2.default.func]),
    autoMinWidth: _propTypes2.default.oneOfType([_propTypes2.default.bool])
};
CNTableColumn.defaultProps = {
    wrap: true,

    copy: false,
    onBeforeCopy: firstArg,

    clickToSelectRow: false,

    greedy: false
};
exports.default = CNTableColumn;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table@0.0.78@@alicd/crui-table/lib/Column.js
// module id = 276
// module chunks = 0